import React, {useState} from 'react';
import Joi from 'joi';
import {
    Date as DateField,
    AutocompleteSelect,
    RadioGroup,
} from 'components/forms/fields';
import EndSection from 'components/forms/EndSection';
import useFieldData from 'components/forms/hooks/useFieldData';
import {Typography} from '@material-ui/core';
import fields from 'components/forms/toar/fields';
import {useGetNVIC} from 'hooks';
import schemas from '../fields/definedSchemas';
import {P} from 'components/TypographyShortcuts';
import Show from 'components/utils/Show';
import {SiteUrls} from '../../../constants';
import {sanitizeNVIC} from 'components/forms/nvic/NVIC';

const schema = {
    nvic_name: Joi.object().messages({
        'object.base': 'Please select TOAR from the list.',
    }),
    nvic_completed: Joi.boolean().required(),
    completed_date: Joi.when(Joi.ref('nvic_completed'), {
        is: true,
        then: schemas.dateRequiredMaxToday.validation,
        otherwise: Joi.string().allow(''),
    }),
    assessor_info_completed: Joi.string().allow(''),
};

const initialValues = {
    nvic_name: '',
    nvic_completed: '',
    completed_date: '',
    assessor_info_completed: '',
};

const TOAR = props => {
    const {data: nvics, isLoading: areNVICSLoading} = useGetNVIC();
    const [, setSelectedNVIC] = useState(null);
    const [completed, setCompleted] = useFieldData('nvic_completed');
    const [assessorCompleted, setAssessorCompleted] = useFieldData(
        'assessor_info_completed'
    );

    const nvicsFilter = nvics?.filter(item =>
        item?.assessed_task_name?.includes('Towing')
    );

    const updateCompleted = e => {
        setCompleted(e.currentTarget.value);
    };

    const updateAssessorCompleted = e => {
        setAssessorCompleted(e.currentTarget.value);
    };

    const showCompleted = completed === true || completed === 'true';

    return (
        <EndSection
            {...props}
            {...{schema, initialValues}}
            endpointOverride='nvic'
            sanitizeFunction={sanitizeNVIC}
            redirectUrl={SiteUrls.TRAINING}
        >
            <Typography variant='h6' align='left'>
                TOAR Info
            </Typography>
            <Typography variant='body1'>
                Let's enter the information about this TOAR.
            </Typography>
            <AutocompleteSelect
                required
                name={fields.nvic_name.name}
                label={fields.nvic_name.label}
                options={nvicsFilter || []}
                loading={areNVICSLoading}
                getOptionLabel={option => option?.assessed_task_name}
                onChangeListener={setSelectedNVIC}
                noOptionsText='No options, please enter at least 3 characters of the TOAR name'
            />
            <RadioGroup
                required
                name={fields.nvic_completed.name}
                label={fields.nvic_completed.label}
                options={{
                    true: 'Yes',
                    false: 'No',
                }}
                onChange={updateCompleted}
            />
            <Show condition={showCompleted}>
                <DateField
                    required
                    name={fields.completed_date.name}
                    label={fields.completed_date.label}
                    inputProps={{type: 'tel'}}
                />
                <RadioGroup
                    required
                    name={fields.assessor_info_completed.name}
                    label={fields.assessor_info_completed.label}
                    options={{true: 'Yes', false: 'No'}}
                    onChange={updateAssessorCompleted}
                />
                <Show condition={assessorCompleted === 'false'}>
                    <P style={{color: 'red'}}>
                        You need to have all of the information about the
                        Designated Examiner(s) on the last page of this TOAR
                        completed before we submit it to the USCG. Keep working
                        on getting that completed and add it again once it's
                        complete.
                    </P>
                </Show>
            </Show>
            {props.children}
        </EndSection>
    );
};

export default TOAR;
